
import { LogLastEntry } from "./log-last-entry.model";
import { RekbotSettings } from "./rekbot-settings.model";
import { RekbotStatusAssets } from "./rekbot-status-assets";

export class Rekbot {
    public id: number;
    public serial_no: string;
    public ipv4: string;
    public organization_id: number;
    public port: number;
    public gps_device_id: string;
    public ipv6?: string;
    public status: number;
    // TODO tymczasowy status
    public status_new: number;
    public statusAssets?: RekbotStatusAssets;
    public production_status?: number;
    public last_synced_at?: string;
    public restart_message?: string;
    public restart_application?: string;
    public restart_api?: string;
    public restart_plc?: string;
    public restart_pc?: string;
    public namedStatus: string;
    public settings?: RekbotSettings;
    public organization?: any;
    public log_last_entry?: LogLastEntry[];


    constructor(
        id: number, 
        serial_no: string, 
        ipv4: string, 
        port: number,
        gps_device_id: string,
        organization_id: number,
        status: number,
        status_new:number,
        // production_status: number,
        ipv6?: string, 
        last_synced_at?: string,
        restart_message?: string,
        restart_application?: string,
        restart_api?: string,
        restart_plc?: string,
        restart_pc?: string,
        ) {
        this.id = id;
        this.serial_no = serial_no;
        this.ipv4 = ipv4;
        this.port = port;
        this.ipv6 = ipv6;
        this.status = status; 
        this.status_new = status_new;
        // this.production_status = production_status;
        this.gps_device_id = gps_device_id;
        this.last_synced_at = last_synced_at; 
        this.restart_message = restart_message; 
        this.restart_application = restart_application; 
        this.restart_api = restart_api; 
        this.restart_plc = restart_plc; 
        this.restart_pc = restart_pc; 
        this.organization_id = organization_id; 
        this.namedStatus = ""; 

    }

    static empty() {
        return new Rekbot(0,"","",0,"",0,0,0);
    }
}